/**
 * Centralized route definitions
 * Use these constants instead of hardcoded route strings throughout the app
 */

export const routes = {
  // Public routes
  home: "/home",
  login: "/login",
  resetPassword: "/reset-password",
  updatePassword: "/update-password",
  about: "/about",
  privacyPolicy: "/privacy-policy",
  termsOfService: "/terms-of-service",
  mindMap: "/mind-map",

  // Protected routes (require authentication)
  problems: "/problems",
  definitionQuiz: "/definition-quiz",
  profile: "/profile",
  leaderboard: "/leaderboard",

  // Dynamic route helpers
  problem: (problemId: string) => `/problems/${problemId}`,
  problemSubmissions: (problemId: string, mode?: string, date?: string) => {
    const params = new URLSearchParams();
    if (mode) params.set("mode", mode);
    if (date) params.set("date", date);
    const query = params.toString();
    return `/problems/${problemId}/submissions${query ? `?${query}` : ""}`;
  },
  conceptDetail: (slug: string) => `/map/${slug}`,
} as const;

/**
 * Helper function to build problem route with query params
 */
export function problemRoute(
  problemId: string,
  options?: { mode?: string; date?: string }
): string {
  const params = new URLSearchParams();
  if (options?.mode) params.set("mode", options.mode);
  if (options?.date) params.set("date", options.date);
  const query = params.toString();
  return `/problems/${problemId}${query ? `?${query}` : ""}`;
}
